import { FC } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useTranslation } from 'react-i18next'

interface Props {
  onClose: () => void
}

export const DontKnowLoginDefault: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()
  return (
    <>
      <DialogContent>
        <Box mt={1}>{t('Auth.Onboarding.default-follow-password')}</Box>
        <Box mt={1}>{t('Auth.Onboarding.mg-incognito-when-logged-in')}</Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid='btn-close-modal'>
          {t('global.close')}
        </Button>
      </DialogActions>
    </>
  )
}
